{
  "publishConfig": {"registry": "https://nexus.pc-scol.fr/repository/npm-local-releases/"},
  "devDependencies": {
    "eslint-config-prettier": "8.10.2",
    "karma-jasmine": "~5.1.0",
    "@angular/build": "^20.3.27",
    "@angular-eslint/eslint-plugin-template": "20.7.0",
    "eslint": "^8.57.0",
    "@angular-eslint/schematics": "20.7.0",
    "@pcscol/eslint-plugin": "30.0.0",
    "@angular/localize": "^20.3.24",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.9.2",
    "karma-coverage": "~2.2.0",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "@angular/compiler-cli": "^20.3.24",
    "@angular-eslint/eslint-plugin": "20.7.0",
    "karma-chrome-launcher": "~3.2.0",
    "@angular/cli": "^20.3.27",
    "eslint-plugin-prettier": "^4.2.5",
    "@typescript-eslint/eslint-plugin": "^8.60.0",
    "ts-node": "^10.9.2",
    "@angular-eslint/template-parser": "20.7.0",
    "@types/node": "^20.19.41",
    "@typescript-eslint/parser": "^8.60.0",
    "@angular-devkit/build-angular": "^20.3.27",
    "@angular-eslint/builder": "^20.7.0"
  },
  "name": "@pcscol/aap-app",
  "files": ["package.json"],
  "repository": {
    "type": "git",
    "url": "https://gitlab.pc-scol.fr/pcscol/aap/aap-app.git"
  },
  "scripts": {
    "lint": "ng lint",
    "extract": "ng extract-i18n --output-path=src/locale",
    "test": "ng test",
    "start:dev": "ng serve -c dev --proxy-config proxy/proxy-dev.config.json",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "start": "ng serve --configuration=fr",
    "ng": "ng"
  },
  "version": "34.0.1",
  "dependencies": {
    "@ngrx/router-store": "^20.1.0",
    "@angular/platform-browser": "^20.3.24",
    "karma-junit-reporter": "^2.0.1",
    "@pcscol/idt-api-v1-angular": "1.4.0",
    "@pcscol/ins-api-v1-angular": "1.4.0",
    "zone.js": "~0.15.1",
    "@angular/router": "^20.3.24",
    "@ngrx/effects": "^20.1.0",
    "@angular/common": "^20.3.24",
    "@angular/core": "^20.3.24",
    "tailwindcss": "^3.4.3",
    "@ngrx/store": "^20.1.0",
    "@angular/animations": "^20.3.24",
    "@pcscol/acs-apprenant-api-v1-angular": "1.0.0",
    "@angular/compiler": "^20.3.24",
    "@pcscol-portail/ng-auth": "20.2.4",
    "@pcscol-portail/ng-authz": "20.2.4",
    "@pcscol/chc-apprenant-api-v1-angular": "1.9.0",
    "@pcscol/authz-autorisation-api-v5-angular": "27.0.0",
    "@pcscol-portail/composants-pegase": "20.2.4",
    "@angular/platform-browser-dynamic": "^20.3.24",
    "rxjs": "~7.8.0",
    "@ngrx/operators": "^20.1.0",
    "@angular/forms": "^20.3.24",
    "@pcscol-portail/theme-pegase-apprenant": "20.2.4",
    "tslib": "^2.3.0"
  }
}